import { CSS, StyleProps } from "@shared/primitive-components"

export const bgGreen = (props: StyleProps): CSS => ({
  backgroundColor: props.theme.palette.full.green,
})

export const bgRed = (props: StyleProps): CSS => ({
  backgroundColor: props.theme.palette.full.red,
})

export const link = (props: StyleProps): CSS => ({
  color: props.theme.palette.grey.dark,
})

export const right0 = (): CSS => ({
  right: 0,
})

export const relative = (): CSS => ({
  position: `relative`,
})

export const tooltipContent = (): CSS => ({
  maxWidth: 240,
})

export const connectivityContent = (props: StyleProps): CSS => ({
  position: `relative`,
  marginRight: props.theme.spacing(6),
})

export const connectivityBar = (props: StyleProps): CSS => ({
  marginTop: props.theme.spacing(6),
  textAlign: `center`,
  overflow: `hidden`,
})

export const connectivityMarker =
  (disconnected?: boolean) =>
  (percentage: number) =>
  (props: StyleProps): CSS => ({
    position: `absolute`,
    color: props.theme.palette.white,
    backgroundColor: disconnected ? props.theme.palette.full.red : props.theme.palette.full.green,
    borderWidth: 3,
    borderStyle: `solid`,
    borderColor: props.theme.palette.white,
    borderRadius: `50%`,
    top: 0,
    left: percentage ? `calc(${percentage}% - 12px)` : -12,
    translate: `0 calc(-50% + 8px)`,
  })

export const connectivityMarkerGreen = connectivityMarker()
export const connectivityMarkerRed = connectivityMarker(true)

export const connectivityText = (props: StyleProps): CSS => ({
  fontSize: props.theme.fontSize.caption,
  fontWeight: `bold`,
  color: props.theme.palette.white,
})
